import {
  createSlice,
} from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { INotificationState } from "./Types";

const initialState: INotificationState = {
  notificationItems: [],
};

const Slice = createSlice({
  name: "notification-reducer",
  initialState,
  reducers: Reducer,
});

export const { clearAllNotifications, setNotificationClose, setNotificationOpen } = Slice.actions;

export default Slice;
